import React from 'react'
import PropTypes from 'prop-types'
import Deductions from './Deductions.js'

const TimeLimit = props => {
  return (
    <div>
      <div className="form-check">
        <label className="form-check-label">
          Time Limit in Minutes:
          <input
            className="form-control"
            type="text"
            value={props.timeLimit}
            onChange={e => {
              let value =
                e.target.value === '' ? null : parseInt(e.target.value)
              props.onTimeLimitChange(value)
            }}
          />
        </label>
        <div className="form-group mt-3">
          <label htmlFor="lateActionDropdown">If the submission is late:</label>
          <select
            className="form-control"
            id="lateActionDropdown"
            value={props.lateAction}
            onChange={e => props.onLateRuleChange(e.target.value)}
          >
            <option value="flag">
              Flag it as late in the grader, but do not deduct any points
            </option>
            <option value="submit">
              Auto-submit the submission; Give credit for what is done
            </option>
            <option value="deduct">
              Automatically deduct points, per the following rules
            </option>
          </select>
          <div className={`${props.lateAction === 'deduct' ? '' : 'd-none'}`}>
            <Deductions
              onChange={props.onDeductionsChange}
              deductions={props.deductions}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

TimeLimit.propTypes = {
  onLateRuleChange: PropTypes.func,
  lateAction: PropTypes.oneOf(['flag', 'submit', 'deduct']),
  timeLimit: PropTypes.number,
  onTimeLimitChange: PropTypes.func,
  onDeductionsChange: PropTypes.func,
  deductions: PropTypes.array,
}

export default TimeLimit
